var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDesktopOnly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 156,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 60.953c42.25 0 76.5 60.797 76.5 18.547S118.75 3 76.5 3 0 37.25 0 79.5s34.25-18.547 76.5-18.547z",
    fill: "#283593"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.834 50.404l-3.111.891a1.38 1.38 0 01-.855-.033.997.997 0 01-.575-.505.726.726 0 01.04-.68 1.06 1.06 0 01.633-.46l3.111-.89a1.38 1.38 0 01.855.032c.268.1.475.282.576.505a.73.73 0 01-.041.681 1.064 1.064 0 01-.633.459z",
    fill: "#6C63FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 114.621h114.963V47.886a1.89 1.89 0 00-.552-1.333 1.878 1.878 0 00-1.329-.553H20.881c-.499 0-.977.2-1.33.553A1.89 1.89 0 0019 47.886v66.735z",
    fill: "#CACACA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.398 48.674H22.564v60.6h107.834v-60.6z",
    fill: "#3C3F43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 111.948v8.382c0 .348.067.692.197 1.013.13.321.32.612.56.858.24.246.526.441.84.574.313.133.65.201.989.201h42.321v16.543h-.562a.335.335 0 00-.31.212.35.35 0 00-.026.132v1.15a.354.354 0 00.099.243.335.335 0 00.238.101h26.272a.334.334 0 00.31-.212.354.354 0 00.026-.132v-1.15a.35.35 0 00-.099-.244.344.344 0 00-.237-.1h-.563v-16.543h42.322c.34 0 .676-.068.99-.201.313-.133.598-.328.839-.574.24-.246.43-.537.56-.858.13-.321.197-.665.197-1.013v-8.382H19z",
    fill: "#7986CB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.97 77.674H80.84c-.329 0-.644-.141-.876-.392a1.393 1.393 0 01-.362-.945c0-.355.13-.695.362-.946.232-.25.547-.391.876-.391h17.13c.328 0 .643.14.875.391.232.251.363.591.363.946 0 .354-.13.694-.363.945-.232.25-.547.392-.875.392zm9.818 5.346H71.911a1.17 1.17 0 01-.864-.39c-.229-.251-.358-.591-.358-.946s.13-.695.358-.945c.23-.251.54-.392.864-.392h35.877c.325 0 .635.141.865.392.229.25.357.59.357.945s-.128.695-.357.945c-.23.25-.54.392-.865.392z",
    fill: "#FFA852"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.964 88.777c5.66 0 10.248-4.788 10.248-10.694 0-5.906-4.588-10.694-10.248-10.694-5.66 0-10.25 4.788-10.25 10.694 0 5.906 4.59 10.694 10.25 10.694z",
    fill: "#44D9E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.481 46.892a.446.446 0 100-.892.446.446 0 000 .892z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.985 35.973c9.933 0 17.986-8.052 17.986-17.985S115.918.002 105.985.002 88 8.055 88 17.988s8.052 17.985 17.985 17.985z",
    fill: "#51D385"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.629 26.98a1.925 1.925 0 01-1.538-.769l-4.714-6.287a1.923 1.923 0 013.075-2.306l3.085 4.112 7.922-11.884a1.924 1.924 0 013.199 2.133l-9.429 14.145a1.927 1.927 0 01-1.6.856z",
    fill: "#fff"
  })));
}

export default SvgDesktopOnly;